/**
 * Shared constants + helpers for the PCB Replacement Management module.
 * Kept separate from All Jobs / SC Jobs pipelines (StatusPipeline.jsx) by design.
 */
import { CheckCircle2, Truck, PackageCheck, Wrench, Undo2, BadgeCheck } from "lucide-react";

export const PCB_STAGES = [
  { key: "pcb_dispatched",         label: "PCB Dispatched",             msg: "Your PCB has been shipped.",         icon: CheckCircle2, color: "#16a34a", bg: "bg-green-600",   soft: "bg-green-50 text-green-700 border-green-200"   },
  { key: "in_transit",             label: "In Transit",                 msg: "Out for delivery.",                  icon: Truck,        color: "#2563eb", bg: "bg-blue-600",    soft: "bg-blue-50 text-blue-700 border-blue-200"      },
  { key: "delivered",              label: "Delivered",                  msg: "PCB delivered to you.",              icon: PackageCheck, color: "#7c3aed", bg: "bg-violet-600",  soft: "bg-violet-50 text-violet-700 border-violet-200"},
  { key: "pcb_replaced",           label: "PCB Replaced",               msg: "Please confirm after replacement.",  icon: Wrench,       color: "#0891b2", bg: "bg-cyan-600",    soft: "bg-cyan-50 text-cyan-700 border-cyan-200"      },
  { key: "old_charger_dispatched", label: "Old Charger Dispatched",     msg: "Share tracking ID.",                 icon: Undo2,        color: "#d97706", bg: "bg-amber-500",   soft: "bg-amber-50 text-amber-700 border-amber-200"   },
  { key: "received_at_sc",         label: "Received at Service Center", msg: "Thank you!",                         icon: BadgeCheck,   color: "#e11d48", bg: "bg-rose-600",    soft: "bg-rose-50 text-rose-700 border-rose-200"      },
];

export const OLD_CHARGER_STATUSES = ["Received", "Under Repair", "Refurbished & Ready"];

export const STOCK_STATUS_STYLES = {
  "In Stock":     "bg-green-50 text-green-700 border-green-200",
  "Low Stock":    "bg-amber-50 text-amber-700 border-amber-200",
  "Out of Stock": "bg-rose-50 text-rose-700 border-rose-200",
};

export const OLD_STATUS_STYLES = {
  "Received":            "bg-slate-100 text-slate-700 border-slate-200",
  "Under Repair":        "bg-amber-50 text-amber-700 border-amber-200",
  "Refurbished & Ready": "bg-green-50 text-green-700 border-green-200",
};

export const CONNECTOR_TYPES = ["3 Pin", "D Type", "Okinawa (Chagori)", "Anderson", "Bullet", "Other"];

/** Today's date as DD/MM/YYYY */
export const todayDDMMYYYY = () => {
  const d = new Date();
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

/** Validate DD/MM/YYYY (calendar-aware) */
export const isValidDDMMYYYY = (v) => {
  if (!/^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/.test(v || "")) return false;
  const [d, m, y] = v.split("/").map(Number);
  const dt = new Date(y, m - 1, d);
  return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
};

/** Auto-insert slashes while typing: 05092026 -> 05/09/2026 */
export const maskDDMMYYYY = (raw) => {
  const digits = (raw || "").replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

/** DD/MM/YYYY -> "05 Sep 2026" for display */
export const prettyDate = (v) => {
  if (!isValidDDMMYYYY(v)) return v || "";
  const [d, m, y] = v.split("/").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const pcbTrackUrl = (dispatchNo) => `${window.location.origin}/pcb-track?ref=${encodeURIComponent(dispatchNo)}`;
